<div class="modal-header">
  <h5 class="modal-title">{{ config.title }}</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <app-rental-select
    [items]="rentals"
    [ctrl]="form.get('rental')"
    [multiple]="config.multiple"
    (selectedItemsChange)="onSelectedRentals($event)"
    placeholder="Select Rental(s)"
    i18n-placeholder
  >
  </app-rental-select>

  <p [innerHTML]="config.help"></p>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light"><i class="far fa-times"></i> Cancel</button>
  <button
    *ngIf="!config.selectOnChange || config.multiple"
    (click)="save(form)"
    type="button"
    class="btn btn-secondary-info create-btn"
  >
    <i class="cs-icon cs-icon-save"></i> {{ config.buttonText }}
  </button>
</div>
